// import locations from './locations'

export default {
  strict: true,
  namespaced: true,
  state: {
    leg1: {
      airline: '',
      airlineCode: '',
      airportCode: '',
      flightNo: '',
      flightAID: '',
      isAirportPickup: false,
      isAirportDropoff: false,
      dropoff: {},
      pickup: {},
      pickupDate: '',
      pickupType: '',
      pickupFee: 0,
      isAsap: false,
      apt: '',
      timezone: 'America/Los_Angeles',
      distance: '',
      eta: '',
      passenger: 1,
      luggage: 1,
      services: {},
      selectedService: '',
      flightDate: ''
    },
    leg2: {
      airline: '',
      airlineCode: '',
      airportCode: 'LAX',
      flightNo: '',
      flightAID: '',
      isAirportPickup: false,
      isAirportDropoff: false,
      dropoff: {},
      pickup: {},
      pickupDate: '',
      pickupType: '',
      pickupFee: 0,
      isAsap: false,
      apt: '',
      timezone: 'America/Los_Angeles',
      distance: '',
      eta: '',
      passenger: 1,
      luggage: 1,
      services: {},
      selectedService: '',
      flightDate: ''
    },
    activeLeg: 'leg1',
    isRoundtrip: false,
    discountTill: '',
    discountTillInUnix: '',
    holiday: {},
    serviceLoading: false,
    showFlightModal: false,
    airlineGID: 0,
    airlineList: {},
    airlineLoading: false,
    flightList: {
      leg1: [],
      leg2: []
    },
    flightLoading: false,
    sharedChangeTime: '',
    sharedNotAvaialble: {
      leg1: false,
      leg2: false
    },
    sharedAllowedTime: {
      start: '',
      end: ''
    },
    webTimeBuffer: '',
    driverResponseTime: '',
    suggestedTime: {
      show: false,
      leg1: {
        show: false,
        time: '',
        isDomestic: ''
      },
      leg2: {
        show: false,
        time: '',
        isDomestic: ''
      }
    },
    customPickupTime: {
      leg1: false,
      leg2: false
    },
    offSets: {},
    applySuggestedLeg2: false,
    getRtPricing: false
  },
  mutations: {
    setPickup (state, data) { state[data.leg].pickup = data.value },
    setDropoff (state, data) { state[data.leg].dropoff = data.value },
    setPickupGeofence (state, data) {
      state[data.leg].pickup.geofenceId = data.id
      state[data.leg].airportCode = data.airportCode
      state[data.leg].pickup.geofenceType = data.type
    },
    setDropoffGeofence (state, data) {
      state[data.leg].dropoff.geofenceId = data.id
      state[data.leg].dropoff.geofenceId = data.id
      state[data.leg].dropoff.geofenceType = data.type
    },
    setAirportCode (state, data) { state[data.leg].airportCode = data.code },
    setFlightNo (state, data) { state[data.leg].flightNo = data.value },
    setIsAirportPickup (state, data) { state[data.leg].isAirportPickup = data.value },
    setIsAirportDropoff (state, data) { state[data.leg].isAirportDropoff = data.value },
    setPickupDate (state, data) { state[data.leg].pickupDate = data.value },
    setPickupType (state, data) {
      state[data.leg].pickupType = data.type
      state[data.leg].pickupFee = data.fee
    },
    setIsAsap (state, data) { state[data.leg].isAsap = data.value },
    setApt (state, data) { state[data.leg].apt = data.value },
    setTimezone (state, data) { state[data.leg].timezone = data.value },
    setDistanceEta (state, data) {
      state[data.leg].distance = data.distance
      state[data.leg].eta = data.eta
    },
    setPassenger (state, data) { state[data.leg].passenger = data.value },
    setLuggage (state, data) { state[data.leg].luggage = data.value },
    setServices (state, data) { state[data.leg].services = data.value },
    setDiscountTill (state, value) { state.discountTill = value },
    setDiscountTillInUnix (state, value) { state.discountTillInUnix = value },
    setHoliday (state, value) { state.holiday = value },
    setServiceLoading (state, value) { state.serviceLoading = value },
    setSelectedService (state, data) { state[data.leg].selectedService = data.value },
    setSharedAllowedTime (state, value) { state.sharedAllowedTime = value },
    setWebTimeBuffer (state, value) { state.webTimeBuffer = value },
    setDriverResponseTime (state, value) { state.driverResponseTime = value },
    setShowFlightModal (state, value) { state.showFlightModal = value },
    setAirlineList (state, data) {
      state.airlineGID = data.id
      state.airlineList = data.list
    },
    setAirline (state, data) {
      state[data.leg].airline = data.airline
      state[data.leg].airlineCode = data.airlineCode
    },
    setAirlineLoading (state, value) { state.airlineLoading = value },
    setFlightLoading (state, value) { state.flightLoading = value },
    setSharedChangeTime (state, value) { state.sharedChangeTime = value },
    setSharedNotAvaialble (state, data) { state.sharedNotAvaialble[data.leg] = data.value },
    setFlightAID (state, data) { state[data.leg].flightAID = data.value },
    setFlightList (state, data) { state.flightList[data.leg] = data.value },
    setIsRoundtrip (state, value) { state.isRoundtrip = value },
    setActiveLeg (state, value) { state.activeLeg = value },
    setSuggestedTimeShowModal (state, value) { state.suggestedTime.show = value },
    setSuggestedTime (state, data) { state.suggestedTime[data.leg].time = data.value },
    setSuggestedTimeIsDomestic (state, data) { state.suggestedTime[data.leg].isDomestic = data.value },
    setSuggestedTimeShowLeg (state, data) { state.suggestedTime[data.leg].show = data.value },
    setFlightDate (state, data) { state[data.leg].flightDate = data.value },
    setCustomPickupTime (state, data) { state.customPickupTime[data.leg] = data.value },
    setOffSets (state, data) { state.offSets[data.id] = data.value },
    addOffSets (state, data) { state.offSets[data.id].push(data.value) },
    setApplySuggestedLeg2 (state, value) { state.applySuggestedLeg2 = value },
    updateServicePriceOnly (state, data) {
      // state[data.leg].services
      for (let service in data.value) {
        if (state[data.leg].services[service]) {
          state[data.leg].services[service].prices = data.value[service].prices
          state[data.leg].services[service].roundtrip = data.value[service].roundtrip
        }
      }
    },
    setRtPricing (state, val) {
      state.getRtPricing = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation/rsvp.js